<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9foaG8/tc-custom/9781466874718.jpg?1737745987920" alt="This image is the cover for the book The Sisters of Blue Mountain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Sisters of Blue Mountain
      </h1>
      <p class="bookDescription body article font2">
        <b>“Evocative, atmospheric and haunting . . . Katchur expertly exposes the fault lines between sisters who share a secret past. I couldn’t put it down.” —Kate Moretti, <i>New York Times</i>–bestselling author of <i>Thought I Knew You</i> and <i>The Vanishing Year</i></b><br/><br/>A sisters’ secret.<br/><br/>A mysterious phenomenon.<br/><br/>A murder that ties it all together.<br/><br/>The small town of Mountain Springs, Pennsylvania thrives on the snow geese migration. Each year, the birds flock to the dam, and the tourists follow, filling up Linnet’s Bed and Breakfast.<br/><br/>But one morning Linnet wakes up to discover hundreds of dead geese by the B&amp;B and her life is thrown into the media frenzy when her father—a former ornithology professor—is asked to study the case. As the tourists cancel their plans and Linnet’s father’s health grows increasingly worse, the last thing she expects is to see her estranged sister, Myna, on her doorstep.<br/><br/>Myna has never stayed in one place for long after running from Mountain Springs. Although she and Linnet were close growing up, a family secret broke their bond, and Myna’s return has brought back memories both sisters have tried to keep buried.<br/><br/>When a reporter arrives in town who may have a connection to the sisters’ past, Linnet and Myna are forced to confront the event that tore them apart. But when a young professor who was assisting their father on the case turns up dead—and their father becomes the primary suspect—Linnet and Myna realize that their secret won’t stay hidden for long . . . <br/><br/>“Katchur weaves a suspenseful tale of family secrets and what it means to keep quiet. For readers who relish complex family mysteries.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Katchur
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d8a822b